import { styled } from '@mui/material';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Skeleton from '@mui/material/Skeleton';
import Typography from '@mui/material/Typography';

interface CardArticleProps {
  image: string;
}

export const GeneralContainer = styled(Container)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  marginBottom: '2.0625rem',
  [theme.breakpoints.down('lg')]: {
    flexDirection: 'column',
    width: '100%',
    alignItems: 'center',
    gap: '1rem',
  },
  a: {
    textDecoration: 'none',
  },
}));

export const LoadingSkeletonPost = styled(Skeleton)(({ theme }) => ({
  marginTop: '1rem',
  width: '35.75rem',
  height: '26.75rem',
  borderRadius: '1rem',
  [theme.breakpoints.down('sm')]: {
    width: '90vw',
    margin: '0 auto',
  },
  [theme.breakpoints.between('sm', 'lg')]: {
    width: '90%',
    margin: '0 auto',
  },
}));

export const LinearGradient = styled(Box)(({ theme }) => ({
  // border: 'solid 1px blue',
  borderRadius: '1rem',
  position: 'relative',
  '&:before': {
    content: "''",
    width: '100%',
    height: '100%',
    position: 'absolute',
    borderRadius: '1rem',
    top: 0,
    right: 0,
    backgroundImage: 'linear-gradient(to bottom, rgba(0, 0, 0, 0) 31%, #1b3448)',
  },
  [theme.breakpoints.between('xs', 'lg')]: {
    width: '90vw',
  },
}));

export const CardArticle = styled(Box)<CardArticleProps>(({ theme, image }) => ({
  backgroundImage: `url(${image})`,
  backgroundRepeat: 'no-repeat',
  backgroundPositionX: 'center',
  backgroundSize: 'cover',
  borderRadius: '1rem',
  width: '35.75rem',
  height: '26.75rem',
  display: 'flex',
  alignItems: 'end',
  [theme.breakpoints.down('lg')]: {
    width: '100%',
  },
  // [theme.breakpoints.between('sm', 'md')]: {
  //   width: '100%',
  // },
  // [theme.breakpoints.between('md', 'lg')]: {
  //   width: '100%',
  // },
}));

export const TextContainer = styled(Box)(({ theme }) => ({
  position: 'relative',
  width: '90%',
  margin: '0 auto 2.5rem',
  zIndex: '3',
}));

export const TitleCard = styled(Typography)(({ theme }) => ({
  ...theme.typography.h5,
  color: 'white',
  fontWeight: theme.typography.fontWeightBold,
  height: '3rem',
}));

export const DateCard = styled(Typography)(({ theme }) => ({
  ...theme.typography.overline,
  color: 'white',
  fontWeight: theme.typography.fontWeightRegular,
  textTransform: 'capitalize',
}));
